package gr.tech.GRAttestation.models.stores

import kotlinx.serialization.Serializable

@Serializable
data class StorePreviewDTO(
    val id: Int,
    val locationId: String,
    val storeName: String,
    val storeAddress: String,
    val storeCity: String,
    val storeState: String,
    val storeZip: String,
)